import { useState } from 'react';
import { Cpu, AlertOctagon } from 'lucide-react';
import GeminiProcessingPage from './GeminiProcessingPage';
import FailedCallsTab from './FailedCallsTab';

// Thin tab shell for the Auto Processing screen. The existing
// GeminiProcessingPage is rendered untouched under the "Auto Processing" tab;
// a new "Permanent Failed Calls" tab is added alongside it. Keeping the tab
// bar in a wrapper (rather than editing GeminiProcessingPage) guarantees the
// existing page's code and behaviour are completely unchanged.
//
// Both tabs stay mounted once visited and are toggled with CSS so their
// internal state (filters, polling, pagination) survives tab switches.
const TABS = [
  { key: 'auto', label: 'Auto Processing', icon: Cpu },
  { key: 'permanent_failed', label: 'Failed Calls', icon: AlertOctagon },
];

export default function AutoProcessingTabs() {
  const [activeTab, setActiveTab] = useState('auto');
  const [visited, setVisited] = useState({ auto: true });

  const selectTab = (key) => {
    setActiveTab(key);
    setVisited((prev) => (prev[key] ? prev : { ...prev, [key]: true }));
  };

  return (
    <div className="space-y-4">
      {/* Tab bar */}
      <div className="flex items-center gap-1 border-b border-border">
        {TABS.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            type="button"
            onClick={() => selectTab(key)}
            className={`flex items-center gap-1.5 px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
              activeTab === key
                ? 'border-primary text-foreground'
                : 'border-transparent text-muted-foreground hover:text-foreground'
            }`}
            data-testid={`auto-processing-tab-${key}`}
          >
            <Icon className="w-3.5 h-3.5" />
            {label}
          </button>
        ))}
      </div>

      {/* Auto Processing (existing page, unchanged) */}
      <div className={activeTab === 'auto' ? '' : 'hidden'}>
        <GeminiProcessingPage />
      </div>

      {/* Permanent Failed Calls (new) — mounted lazily on first visit. */}
      {visited.permanent_failed && (
        <div className={activeTab === 'permanent_failed' ? '' : 'hidden'}>
          <FailedCallsTab />
        </div>
      )}
    </div>
  );
}
